import React, { useState } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import RoleLoginForm from "../../components/RoleLoginForm/RoleLoginForm";
import _LoanOfficerService from "../../modules/LoanOfficerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { routes } from "../../routes/Routes";

const RoleLoginLoanOfficer = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinishHandle = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
            };
            const res = await _LoanOfficerService.loanOfficerLogin(reqObj);
            if (res?.data?.IsSuccess) {
                localStorage.setItem("LoanOfficerEmailId", res.data.Obj.Email);
                localStorage.setItem("LoanOfficerId", res.data.Obj.Id);
                localStorage.setItem("LoanOfficerFirstName", res.data.Obj.FirstName);
                localStorage.setItem(SESSION_TOKEN, res.data.Obj.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));
                localStorage.setItem("IsFromNewLoginPage", routes.roleLoginLoanOfficer.path);
                history.push(routes.loanOfficerDashboard.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.error(err);
            message.error("An error occurred during login");
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push({ pathname: routes.forgotLoanOfficerLoginPasswordSendOTP.path, state: { fromNewLoginPage: routes.roleLoginLoanOfficer.path } });
    };

    return (
        <Spin spinning={loading}>
            <RoleLoginForm
                title="Loan Officer Portal"
                onFinishHandle={onFinishHandle}
                forgotPassword={forgotPassword}
                isNewAccountCreateFlag={false}
                onBack={() => history.push(routes.loginNewPage.path)}
            />
        </Spin>
    );
};

export default RoleLoginLoanOfficer;
